import { Component, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { finalize } from 'rxjs/operators'
import { ApiService } from 'src/app/services/api.service'
import { AzureMarketplaceSubscriptionDto } from 'src/app/services/dtos'
import { UiService } from 'src/app/services/ui.service'
import { handleArpioError } from 'src/utils/handle-error'
import { subscriptionActive } from 'src/utils/rxjs-utils'

@Component({
  selector: 'app-azure-marketplace',
  templateUrl: './azure-marketplace.component.html',
  styleUrls: ['./azure-marketplace.component.scss'],
  standalone: false,
})
export class AzureMarketplaceComponent implements OnInit, OnDestroy {
  private token: string = null
  subscription: AzureMarketplaceSubscriptionDto = null
  loading: boolean = true
  activating: boolean = false
  private loadSubscription: Subscription = null

  constructor(
    private activatedRoute: ActivatedRoute,
    public uiService: UiService,
    private apiService: ApiService,
    private router: Router
  ) {}

  ngOnInit() {
    this.token = this.activatedRoute.snapshot.queryParamMap.get('token')
    if (!this.token) {
      this.router.navigateByUrl(this.uiService.azureMarketplaceErrorUrl)
    } else {
      this.loadSubscription = this.apiService
        .getAzureMarketplaceSubscription(this.token)
        .pipe(
          finalize(() => {
            this.loading = false
            this.loadSubscription = null
          })
        )
        .subscribe(
          (subscription) => (this.subscription = subscription),
          handleArpioError(window.location.href, this.apiService, this.uiService)
        )
    }
  }

  ngOnDestroy() {
    if (subscriptionActive(this.loadSubscription)) {
      this.loadSubscription.unsubscribe()
    }
  }

  newAccountClick() {
    this.activating = true
    this.apiService
      .activateAzureMarketplaceSubscription(this.token)
      .pipe(finalize(() => (this.activating = false)))
      .subscribe(
        (account) => {
          this.router.navigateByUrl(this.uiService.buildAccountRootUrl(account.accountId))
        },
        handleArpioError(window.location.href, this.apiService, this.uiService)
      )
  }

  existingAccountClick() {
    this.router.navigateByUrl(this.uiService.buildLinkAzureMarketplaceToAccountUrl(this.token))
  }
}
